import { useState } from "react";
import "./Transfers.css";

export default function Transfers() {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    pickup: "",
    dropoff: "",
    date: "",
    passengers: "",
    message: "",
  });

  const whatsappNumber = "+255718665620";

  const onChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();

    const text = `Hello, I want to book a transfer:
Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Pickup Location: ${form.pickup}
Dropoff Location: ${form.dropoff}
Date: ${form.date}
Passengers: ${form.passengers}
Message: ${form.message}`;

    const sanitizedNumber = whatsappNumber.replace(/\D/g, "");
    const url = `https://wa.me/${sanitizedNumber}?text=${encodeURIComponent(
      text
    )}`;

    window.open(url, "_blank");

    setForm({
      name: "",
      email: "",
      phone: "",
      pickup: "",
      dropoff: "",
      date: "",
      passengers: "",
      message: "",
    });
    setShowForm(false);
  };

  return (
    <section className="transfers">
      {/* Hero header */}
      <header
  className="hero"
  style={{
    backgroundImage: "url(/images/transfer2.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }}
>

  <h2>Zanzibar Transfers & Taxi Services</h2>
  <p className="tagline">
    Specialised in 24/7 Zanzibar taxi services, airport transfers, shuttles,
    and car rentals. <strong>Book now & enjoy 40% off!</strong>
  </p>
</header>

      {/* Transfer options grid */}
      <div className="transfer-grid">
        <div className="transfer-card">
          <img
            src="/images/airtransfer.webp"
            alt="Airport Transfers"
            className="card-image"
          />
          <h3>✈️ Airport Transfers</h3>
          <p>
            Comfortable A/C minibuses (up to 7 seats, or 5 with luggage). For
            larger groups, buses are available. Meet-and-greet service at
            Zanzibar Airport or Ferry Port with a name sign.
          </p>
        </div>

        <div className="transfer-card">
          <img
            src="/images/interisland.jpg"
            alt="Inter-Island Transfers"
            className="card-image"
          />
          <h3>🛥️ Inter-Island Transfers</h3>
          <p>
            Reliable boat and ferry transfers arranged with trusted operators
            for smooth island hopping.
          </p>
        </div>

        <div className="transfer-card">
          <img
            src="/images/private.webp"
            alt="Private Transfers"
            className="card-image"
          />
          <h3>🚗 Private Transfers</h3>
          <p>
            Door-to-door private transfers for families, couples, or groups —
            tailored to your schedule.
          </p>
        </div>
      </div>

      {/* Pricing section */}
      <section className="pricing">
        <h3>💰 Prices per Car (1–7 people)</h3>
        <div className="pricing-grid">
          <div className="price-card">
            <span className="route">Zanzibar Airport → Stone Town</span>
            <span className="price">15 EURO</span>
          </div>
          <div className="price-card">
            <span className="route">
              Airport / Stone Town → Bwejuu, Paje, Jambiani, Kiwengwa,
              Matemwe, Uroa, Pwani-Mchangani
            </span>
            <span className="price">50 EURO</span>
          </div>
          <div className="price-card">
            <span className="route">
              Airport / Stone Town → Kendwa, Nungwi, Michamvi, Kizimkazi
            </span>
            <span className="price">60 EURO</span>
          </div>
          <div className="price-card">
            <span className="route">Other destinations</span>
            <a
              href="https://wa.me/255718665620"
              target="_blank"
              rel="noopener noreferrer"
              className="ask-link"
            >
              Ask Us
            </a>
          </div>
        </div>
      </section>

      {/* Call to action */}
      <footer className="cta">
        <button className="btn-primary" onClick={() => setShowForm(true)}>
          Book Your Transfer Now
        </button>
      </footer>

      {/* Booking Form Overlay */}
      {showForm && (
        <div className="booking-form-overlay">
          <form className="booking-form" onSubmit={onSubmit}>
            <h3>Transfer Booking Form</h3>

            <label>
              Name
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Email
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Phone
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Pickup Location
              <input
                type="text"
                name="pickup"
                value={form.pickup}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Dropoff Location
              <input
                type="text"
                name="dropoff"
                value={form.dropoff}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Date & Time
              <input
                type="datetime-local"
                name="date"
                value={form.date}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Number of Passengers
              <input
                type="number"
                name="passengers"
                value={form.passengers}
                onChange={onChange}
                required
              />
            </label>

            <label>
              Additional Message
              <textarea
                name="message"
                value={form.message}
                onChange={onChange}
                rows="4"
              />
            </label>

            <div className="form-actions">
              <button type="submit" className="btn-primary">
                Send via WhatsApp
              </button>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </section>
  );
}
